import React, { Suspense } from "react";
import ProgressBar from "../ProgressBar/ProgressBar";

function Map() {
  return (
    <>
      <section
        id="locate"
        // className=" pt-4"
      >
        {/* <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3920.767411792373!2d75.99999861414913!3d10.67515326397543!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba7bf434c9d2f8f%3A0x87ceab85f10e82dd!2sGuruvayur!5e0!3m2!1sen!2sin!4v1621169288241!5m2!1sen!2sin"
          width="100%"
          height="350px"
          title="Map"
          style={{ border: "0" }}
          allowFullScreen=""
          loading="lazy"
        ></iframe> */}
        <Suspense fallback={<ProgressBar />}>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d31099.50623901029!2d77.54980773112119!3d13.007738477867987!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae3d7fff79cfc3%3A0xdfbaac7a46a4a5be!2sMalleswara%2C%20Bengaluru%2C%20Karnataka%2C%20India!5e0!3m2!1sen!2sbd!4v1639235197229!5m2!1sen!2sbd"
            width="100%"
            height="350px"
            title="Map"
            style={{ border: "0" }}
            allowFullScreen=""
            // loading="lazy"
          ></iframe>
        </Suspense>
      </section>
    </>
  );
}

export default Map;
